import React from 'react';
import {
  IonButton,
  IonContent,
  IonSpinner,
  useIonViewWillLeave,
} from '@ionic/react';
import { useShareWizardContext } from '@/contexts/ShareWizardContext';
import { ActionGuard } from '@/components/ActionGuard';
import { ActionGuardContainer } from '@/components/ActionGuardContainer';
import { ACTIONS, RESOURCES } from '@/contexts/CasbinContext';
import GardenSharePage from './GardenSharePage';
import RecipientPickerBody from './RecipientPickerBody';
import RecipientsSkeleton from './RecipientsSkeleton';
import { SHARE_STEP_HELP_TEXT } from './ShareContentSkeleton';
import { RecipientPickerLogic } from './recipient_picker_logic';
import styles from './RecipientPicker.module.css';

const RecipientPicker: React.FC = () => {
  const { topic, isTopicLoading, topicError, recipients, nav } =
    useShareWizardContext();

  useIonViewWillLeave(() => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  });

  return (
    <GardenSharePage title="Recipients">
      {/* Some ways into the flow (the welcome sheet's reshare prompt, a shared
          link) skip the share dock's guard, so the step checks share:topics
          itself: a sender who can't share yet sees what they still owe in
          place of the picker, rather than choosing people for a share the
          composer would then refuse. */}
      <ActionGuardContainer>
        <ActionGuard
          disableMode="hidden"
          optimistic
          action={ACTIONS.SHARE}
          resource={RESOURCES.TOPICS}
          resourceId={topic?.id}
          helpText={SHARE_STEP_HELP_TEXT}
          fallbackElem={lock => <RecipientsSkeleton lock={lock} />}
          guardedElem={
            <IonContent className={styles.content}>
              <div className={styles.body} data-testid="garden-recipients">
                {isTopicLoading ? (
                  <div className={styles.status}>
                    <IonSpinner />
                  </div>
                ) : topicError ? (
                  <div className={styles.status}>
                    <p className={styles.error}>{topicError}</p>
                    <IonButton onClick={nav.exit} fill="clear">
                      Close
                    </IonButton>
                  </div>
                ) : (
                  <RecipientPickerBody
                    ctaLabel={RecipientPickerLogic.ctaLabel(recipients.length)}
                    onAdvance={() => nav.goForward()}
                    ctaTestId="garden-recipients-continue"
                  />
                )}
              </div>
            </IonContent>
          }
        />
      </ActionGuardContainer>
    </GardenSharePage>
  );
};

export default RecipientPicker;
